import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import HomeBannerPng from '../../assets/onboarding/homebanner.png';
// import Banner from '../../assets/onboarding/banner.svg';

// const HomeBanner = styled(Banner as React.SFC<React.SVGProps<SVGSVGElement>>)`
//   width: ${props => props.width || '57rem'};
//   height: ${props => props.height || '20rem'};
//   display: flex;
// `;

const HomeBanner = () => {
  const [imgSrc, setImgSrc] = useState('');

  useEffect(() => {
    setImgSrc(HomeBannerPng);
  }, []);

  return <img src={imgSrc ? imgSrc : null} alt="banner" />;
};

export default HomeBanner;
